const location = loc => {
  sendNavMessageToParent(loc)
}

export default location
